import React, { useState } from "react";
import { useHistory } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import { alpha } from "@material-ui/core/styles/colorManipulator";
import classnames from "classnames";

import { useDataProvider, useNotify, Button, Confirm } from "react-admin";

import { DeleteIcon } from "../../../components/common/iconography";
import { logError } from "../../../utils/appUtils";
import { InventoryStatus } from "../../../utils/constants";
import { handleInventoryDelete } from "../../../managerApp/resources/inventory/InventoryUitls";
import { deepRedirect } from "../../../utils/utils";

const useStyles = makeStyles(
  (theme) => ({
    deleteButton: {
      color: theme.palette.error.main,
      "&:hover": {
        backgroundColor: alpha(theme.palette.error.main, 0.12),
        // Reset on mouse devices
        "@media (hover: none)": {
          backgroundColor: "transparent",
        },
      },
    },
  }),
  { name: "RaDeleteWithConfirmButton" },
);

export const DeepDeleteButton = ({
  record,
  inbound,
  backPath,
  resource,
  className,
  isSaving,
  isDeleting,
  setIsDeleting,
  ...props
}) => {
  const classes = useStyles();
  const dataProvider = useDataProvider();
  const history = useHistory();
  const notify = useNotify();
  const [open, setOpen] = useState(false);

  const handleDialogOpen = () => setOpen(true);
  const handleDialogClose = () => setOpen(false);

  const handleDelete = async (event) => {
    setIsDeleting(true);
    setOpen(false);
    try {
      debugger;
      await handleInventoryDelete(record, dataProvider);

      notify("Tally Sheet item deleted successfully", "success");
      deepRedirect(history, backPath);
    } catch (err) {
      logError("inventory:DeepDeleteButton:handleDelete", err, notify);
    } finally {
      setIsDeleting(false);
    }
  };

  if (
    !record ||
    record?.status === InventoryStatus.STORED ||
    record?.status === InventoryStatus.AGGREGATED ||
    record?.status === InventoryStatus.SHIPPED
  ) {
    return null;
  }
  return (
    <>
      <Button
        {...props}
        label="Delete"
        disabled={isDeleting || isSaving}
        onClick={handleDialogOpen}
        className={classnames(
          "ra-delete-button",
          classes.deleteButton,
          className,
        )}
      >
        <DeleteIcon />
      </Button>
      <Confirm
        isOpen={open}
        loading={isDeleting}
        title="Delete Confirmation"
        content="Are you sure you want to delete this Tally Sheet item?"
        onConfirm={handleDelete}
        onClose={handleDialogClose}
      />
    </>
  );
};
